module.exports = __webpack_public_path__ + "img/golf-icon.12f311ec.svg";